import PageLayout from "@/components/aoria/PageLayout";
import Seo from "@/components/aoria/Seo";
import { ORG } from "@/lib/org";

export default function Cookies() {
    return (
        <PageLayout testid="cookies-page">
            <Seo
                title="Politique de cookies · Aoria"
                description="Politique de cookies d'Aoria : approche sobre, cookies strictement nécessaires, mesure d'audience anonymisée, gestion des préférences."
                path="/cookies"
            />
            <article className="max-w-3xl mx-auto px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <span className="eyebrow">Traceurs</span>
                <h1 className="h1 mt-6 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A]">
                    Politique de cookies
                </h1>
                <p className="mt-6 text-[#5C6B7D] leading-relaxed">
                    Aoria privilégie une approche sobre des traceurs. Le site
                    fonctionne sans collecte intrusive et sans publicité
                    comportementale.
                </p>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Cookies strictement nécessaires
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Ces cookies, déposés par notre hébergeur, sont
                        indispensables au bon fonctionnement et à la sécurité du
                        site (équilibrage de charge, prévention des abus). Ils
                        ne nécessitent pas votre consentement et sont conservés
                        le temps de la session ou pour une durée maximale de
                        treize mois.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Mesure d'audience
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Le site peut utiliser un outil de mesure d'audience
                        respectueux de la vie privée. Les données sont
                        agrégées, anonymisées et utilisées uniquement à des
                        fins statistiques internes (consultation des pages,
                        temps de lecture, terminaux). Aucun profilage
                        publicitaire n'est mis en place.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Gérer vos préférences
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Vous pouvez à tout moment configurer ou supprimer les
                        cookies depuis les paramètres de votre navigateur. Cette
                        opération ne dégrade pas l'accès aux contenus
                        éditoriaux d'Aoria.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Questions
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Pour toute question relative à cette politique, écrire
                        à{" "}
                        <a
                            href={`mailto:${ORG.email}`}
                            className="link-underline"
                        >
                            {ORG.email}
                        </a>
                        .
                    </p>
                </section>
            </article>
        </PageLayout>
    );
}
